import { render } from "./UpdateCalculation.vue?vue&type=template&id=3a91a5b7&scoped=true&ts=true"
import script from "./UpdateCalculation.vue?vue&type=script&lang=ts"
export * from "./UpdateCalculation.vue?vue&type=script&lang=ts"

import "./UpdateCalculation.vue?vue&type=style&index=0&id=3a91a5b7&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a91a5b7"]])

export default __exports__